import { Tooltip } from '@chakra-ui/react';
import { Fragment } from 'react';

interface ElementWithFeedbackContainerProps {
  errors: string | string[] | undefined;
  children: React.ReactElement;
  messageContainerClassName?: string;
}
export const ElementWithFeedbackContainer = (
  props: ElementWithFeedbackContainerProps,
) => {
  const { errors, messageContainerClassName } = props;
  const errorsList: string[] = [];
  if (errors) {
    if (typeof errors === 'string') {
      errorsList.push(errors);
    } else {
      errors.forEach((err) => errorsList.push(err));
    }
  }
  const message = errorsList.map((a, index) => (
    <Fragment key={index}>
      {index > 0 ? <br /> : null}
      {a}
    </Fragment>
  ));
  const hasMessage = errorsList.length > 0;

  return (
    <Fragment>
      <Tooltip
        className={messageContainerClassName}
        label={message}
        placement='top-start'
        bg='#f50'
        color='white'
        display={hasMessage ? '' : 'none'}
        shouldWrapChildren
      >
        {props.children}
      </Tooltip>
    </Fragment>
  );
};
